module.exports = __webpack_public_path__ + "static/media/16_plantilla_cuadrada_combo_simple_cp_stills_tetra_200_cepita_multi.23c72aac.png";